import { create } from "zustand";
import type { IPost } from "../types/models/post.models.types";

interface IPostStore {
  data: IPost[];
  setData: (data: IPost[] | ((prevData: IPost[]) => IPost[])) => void;
  removeById: (id: string) => void;  // Add a removeById method
}

const usePostStore = create<IPostStore>((set) => ({
  data: [],
  setData: (data) =>
    set((state) => ({
      data: typeof data === "function" ? data(state.data) : data,
    })),
  removeById: (id) =>
    set((state) => ({
      data: state.data.filter((post) => post.id !== id),
    })),
}));

export default usePostStore;
